<template>
  <section>
    <b-row>
      <b-form-group class="col-sm-6" label="For Client:">
        <b-v-select :disabled="viewOnly" name="form-input-brandId" v-model="reportFilters.brandId" :searchable="true"
          :options="brandsList" />
      </b-form-group>
      <b-form-group class="col-sm-6" label="From Warehouse:">
        <b-v-select :disabled="viewOnly" name="form-input-warehouseId" v-model="reportFilters.warehouseId" :searchable="true"
          :options="warehousesListAll" />
      </b-form-group>
      <b-form-group label="" class="col-12">
        <b-form-checkbox
          v-model="reportFilters.includeWareTransactions"
          name="check-button"
          :disabled="viewOnly"
          switch
        >
          Include Warehouse Transactions in report
        </b-form-checkbox>
      </b-form-group>
      <b-form-group label="" class="col-12">
        <b-form-checkbox
          v-model="reportFilters.excludeManualShipments"
          name="check-button"
          :disabled="viewOnly"
          switch
        >
          Exclude Bulk Shipments
        </b-form-checkbox>
      </b-form-group>
      <b-form-group class="col-sm-6" label="Include ShipTo Country Codes:">
        <b-v-select-multi :disabled="viewOnly" 
          name="form-input-includeCountryCodesPicked"
          v-model="reportFilters.includeCountryCodes"
          :searchable="true"
          :options="countryCodeList" />
      </b-form-group>
      <b-form-group class="col-sm-6" label="Exclude ShipTo Country Codes:">
        <b-v-select-multi :disabled="viewOnly" 
          name="form-input-excludeCountryCodesPicked"
          v-model="reportFilters.excludeCountryCodes"
          :searchable="true"
          :options="countryCodeList" />
      </b-form-group>
      <b-col cols="12">
        <b-form-group label="For:" description="From Date must be before To Date">
          <b-form-select :disabled="viewOnly" v-model="reportFilters.dateFilter" :options="projectDateOpts" required />
        </b-form-group>
      </b-col>
      <template v-if="reportFilters.dateFilter == 'custom'">
        <div class="col-6">
          <b-form-group label="From Shipped Date:" description="From Date must be before To Date">
            <Flatpickr :disabled="viewOnly" v-model="reportFilters.startDate" :config="flatpickrConfig" class="form-control flatpickr-input"
              placeholder="Select date" required />
          </b-form-group>
        </div>
        <div class="col-6">
          <b-form-group label="To Date:">
            <Flatpickr :disabled="viewOnly" v-model="reportFilters.endDate" :config="flatpickrConfig" class="form-control flatpickr-input"
              placeholder="Select date" required />
          </b-form-group>
        </div>
      </template>
    </b-row>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  mixins: [myCommonDataMixin],
  name: 'FactoringFinanceInvoiceReport-form',
  components: {
  },
  props: {
    reportFilters: {
      type: Object,
      required: true
    },
    viewOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      projectsList: 'getProjectsList',
      myProjs: 'getMyProjects',
      countryCodeList: 'getCountryCodeList',
      USAStateCodeList: 'getUSAStateCodeList'
    })
  },
  data() {
    return {
      projectDateOpts: [
        // { value: '', text: "All" },
        { value: 'this-week', text: 'This Week' },
        { value: 'last-week', text: 'Last Week' },
        { value: 'this-month', text: 'This Month' },
        { value: 'last-month', text: 'Last Month' },
        { value: 'custom', text: 'Custom Date Range' }
      ],
      flatpickrConfig: {
        altFormat: 'j F Y',
        altInput: true,
        dateFormat: 'Y-m-d'
      }
    }
  }
}
</script>

<style>

</style>
